// 数据治理
export default [
  {
    path: '/data',
    redirect: '/data/migrate-out',
  },
  {
    path: '/data/migrate-out',
    name: 'data-migration-output',
    component: () => import(/* webpackChunkName: "data" */ '@/views/data/output/Index.vue'),
    meta: { title: '数据迁出' },
  },
  {
    path: '/data/migrate-in',
    name: 'data-migration',
    component: () => import(/* webpackChunkName: "data" */ '@/views/data/migration/Index.vue'),
    meta: { title: '数据迁入' },
  },
  {
    path: '/data/migrate-log',
    name: 'data-migration-log',
    component: () => import(/* webpackChunkName: "data" */ '@/views/data/log/Index.vue'),
    meta: { title: '数据操作日志' },
  },
  {
    path: '/data/updation',
    name: 'data-updation',
    component: () => import(/* webpackChunkName: "data" */ '@/views/data/updation/Index.vue'),
    meta: { title: '清理更新' },
  },
];
